import React from 'react';
import { Euro, Package, ShoppingCart, Users, TrendingUp } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { formatPrice } from '../../lib/utils';

export const DashboardStatsCards = ({ stats }) => {
    const cards = [
        { label: "Chiffre d'affaires", value: formatPrice(stats?.total_revenue || 0), icon: Euro, color: 'leaf', testId: 'total-revenue' },
        { label: 'Commandes', value: stats?.total_orders || 0, icon: Package, color: 'jungle', testId: 'total-orders' },
        { label: 'En attente', value: stats?.pending_orders || 0, icon: ShoppingCart, color: 'terracotta', testId: 'pending-orders' },
        { label: 'Clients', value: stats?.total_clients || 0, icon: Users, color: 'sage', testId: 'total-clients' },
        { label: 'Produits', value: stats?.total_products || 0, icon: TrendingUp, color: 'leaf', testId: 'total-products' },
    ];

    const colorMap = {
        leaf: { bg: 'bg-leaf/10', text: 'text-leaf' },
        jungle: { bg: 'bg-jungle/10', text: 'text-jungle' },
        terracotta: { bg: 'bg-terracotta/10', text: 'text-terracotta' },
        sage: { bg: 'bg-sage/20', text: 'text-sage' },
    };

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
            {cards.map(({ label, value, icon: Icon, color, testId }) => (
                <Card key={testId} className="border-0 bg-white/80 backdrop-blur-sm shadow-sm rounded-2xl">
                    <CardHeader className="flex flex-row items-center justify-between pb-2">
                        <CardTitle className="text-sm font-medium text-muted-foreground">{label}</CardTitle>
                        <div className={`w-10 h-10 rounded-xl ${colorMap[color]?.bg || 'bg-leaf/10'} flex items-center justify-center`}>
                            <Icon className={`h-5 w-5 ${colorMap[color]?.text || 'text-leaf'}`} />
                        </div>
                    </CardHeader>
                    <CardContent>
                        <div className={`text-2xl font-bold ${color === 'terracotta' ? 'text-terracotta' : color === 'leaf' ? 'text-leaf' : 'text-jungle'}`} data-testid={testId}>
                            {value}
                        </div>
                    </CardContent>
                </Card>
            ))}
        </div>
    );
};
